import { useEffect, useRef } from 'preact/hooks';
import { renderSignInButton } from './google-auth';
import { getBrand } from '../brands';

export function AuthPage() {
  const btnRef = useRef<HTMLDivElement>(null);
  const brand = getBrand();

  useEffect(() => {
    if (btnRef.current) {
      renderSignInButton(btnRef.current);
    }
  }, []);

  return (
    <div class="auth-page">
      <div class="auth-container">
        <div class="auth-header">
          <h1>{brand.name}</h1>
          <p>{brand.tagline}</p>
        </div>
        <div ref={btnRef} style={{ display: 'flex', justifyContent: 'center' }} />
        {/* Non-FedCM fallback for de-Googled devices (microG/GmsCore) where the FedCM
            account chooser dead-ends. A plain <a> (not GIS JS) so it works even if the
            FedCM/GIS path fails entirely. Routes through nginx /api/ → backend. #1733 */}
        <div class="auth-fallback">
          <a href="/api/auth/google/start">Trouble signing in? Use redirect &rarr;</a>
        </div>
      </div>
      <style>{`
        .auth-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--bg-primary, #1a1a2e);
        }
        .auth-container {
          width: 100%;
          max-width: 420px;
          padding: 24px;
        }
        .auth-header {
          text-align: center;
          margin-bottom: 32px;
        }
        .auth-header h1 {
          font-size: 24px;
          margin: 0 0 8px;
          color: var(--text-primary, #e0e0ff);
        }
        .auth-header p {
          color: var(--text-secondary, #8888aa);
          font-size: 14px;
        }
        .auth-fallback {
          text-align: center;
          margin-top: 18px;
        }
        .auth-fallback a {
          color: var(--text-secondary, #8888aa);
          font-size: 13px;
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}
